export namespace QueryParam {
  export function has(param: string) {
    return get(param) !== null;
  }

  export function get(param: string) {
    if (typeof window === 'undefined') return null;
    return new URL(window.location.href).searchParams.get(param);
  }
}
